<template>
  <div>

    <h4 class='ma-5'>{{$t('Patient Financial Responsibilities')}}</h4>

    <p class='ma-5'>

    <ul>

      <li>
        {{$t('The patient (or patient’s guardian, if a minor) is ultimately responsible for the payment for his/her treatment and care.')}}

      </li>

      <li> {{$t('We are pleased to assist you by billing your insurance. However, the patient is required to provide us with the most correct and updated information about their insurance, and will be responsible for any charges incurred if the information provided is not correct or updated.')}}

      </li>

      <li> {{$t('If the appointment is not covered by your insurance, you will be billed the full cost of the appointment, which is $250. If you choose to not go through your insurance and pay for the visit out-of-pocket, the prompt pay price for an appointment is $200 (must be paid at or before the time of your appointment)')}}</li>

      <li>
        {{$t('Patients may incur, and are responsible for the payment of additional charges at the discretion of Genetic Support Foundation. These charges may include: Any costs associated with collection of patient balances.')}}

      </li>

    </ul>

    </p>

    <v-card-text>

      <v-row>

        <v-col
          cols="12"
          md="4"
        >

          <v-hover v-slot="{ hover }">

            <v-card
              @click='insurance'
              :elevation="hover ? 12 : 2"
              class="d-flex align-center"
              style='cursor:pointer'
              height="200"
            >

              <v-card-text class="font-weight-medium  text-center subtitle-1">

                <p>

                  <v-icon
                    size='50'
                    color="green darken-2"
                  >

                    mdi-medical-bag

                  </v-icon>

                </p>

                {{$t("I would like GSF to bill my insurance for the genetic counseling appointment")}}

              </v-card-text>

            </v-card>

          </v-hover>

        </v-col>

        <v-col
          cols="12"
          md="4"
        >

          <v-hover v-slot="{ hover }">

            <v-card
              :elevation="hover ? 12 : 2"
              style='cursor:pointer'
              class="d-flex align-center"
              @click="fa()"
              height="200"
            >

              <v-card-text class="font-weight-medium mb-5  text-center subtitle-1">

                <p>

                  <v-icon
                    size='50'
                    color="green darken-2"
                  >

                    mdi-clipboard

                  </v-icon>

                </p>
                {{$t("I would like to apply for financial assistance")}}

              </v-card-text>

            </v-card>

          </v-hover>

        </v-col>

        <v-col
          cols="12"
          md="4"
        >

          <v-hover v-slot="{ hover }">

            <v-card
              :elevation="hover ? 12 : 2"
              style='cursor:pointer'
              class="d-flex align-center"
              @click="cc()"
              height="200"
            >

              <v-card-text class="font-weight-medium mb-5  text-center subtitle-1">

                <p>

                  <v-icon
                    size='50'
                    color="green darken-2"
                  >

                    mdi-credit-card

                  </v-icon>

                </p>

                {{$t("I would like to pay for the visit using my credit card")}}

              </v-card-text>

            </v-card>

          </v-hover>

        </v-col>

      </v-row>

    </v-card-text>

  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  methods: {
    fa() {
      this.form.paymentMethod = "fa";
      this.currentStep = 4;
    },
    cc() {
      this.form.paymentMethod = "cc";
      this.currentStep = 4;
    },
    insurance() {
      this.form.paymentMethod = "insurance";
      this.currentStep = 4;
    },
  },
  computed: {
    ...mapFields([
      "form",
      "currentStep",
      "selectedStateID",
      "selectedMonth",
      "selectedDate",
      "selectedGC",
      "selectedTime",
      "doctorReferece",
      "userProfile",
    ]),
  },
  data() {
    return {
      paymentDialog: false,
      insuraceDialog: false,
      method: null,
    };
  },
};
</script>